<ng-template #settingsTemplate> </ng-template>
<ng-template #contentTemplate>
    <div class="word-flasher-container">
        <div class="word-flasher-container__header">
            <span><i class="fas fa-bolt"></i> Flitsoefening</span>
        </div>
        @if (!showPackageSelector) {
        <div class="word-flasher-container__content">
            <div class="word-flasher-container__option">
                <div class="word-flasher-container__option__header">
                    Woorden ({{ selections.items?.length }})
                </div>
                <div
                    class="word-flasher-container__btn-selector word-flasher-container__btn-selector--active"
                    (click)="showPackageSelector = true"
                >
                    {{ selections.package ? selections.package : 'Laden' }}
                </div>
            </div>
            <div class="word-flasher-container__option">
                <div class="word-flasher-container__option__header">
                    Tijd in beeld
                </div>
                <app-circle-selector
                    [options]="showTimes"
                    [(selectedValue)]="selections.showTime"
                ></app-circle-selector>
            </div>
            <div class="word-flasher-container__option">
                <div class="word-flasher-container__option__header">
                    Blanco tijd
                </div>
                <app-circle-selector
                    [options]="hiddenTimes"
                    [(selectedValue)]="selections.hiddenTime"
                ></app-circle-selector>
            </div>
            <div class="word-flasher-container__option">
                <div class="word-flasher-container__option__header">
                    Aantal woorden
                </div>
                <app-circle-selector
                    [options]="numberOfWords"
                    [(selectedValue)]="selections.numberOfWords"
                ></app-circle-selector>
            </div>
            <div class="word-flasher-container__cta-container">
                <app-button
                    class="solid call-to-action"
                    (click)="startFlits()"
                    [disabled]="!selections.items.length"
                >
                    start
                </app-button>
            </div>
        </div>
        } @if (showPackageSelector) {
        <div
            class="word-flasher-container__content word-flasher-container__package-selector"
        >
            @for (wordPackage of (allPackages$ | async); track wordPackage) {
            <div
                class="word-flasher-container__btn-selector"
                (click)="
                    selectPackage(wordPackage); showPackageSelector = false
                "
                [ngClass]="{
                    'word-flasher-container__btn-selector--active':
                        wordPackage.name === selections.package
                }"
            >
                <span class="name">{{ wordPackage.name }}</span>
            </div>
            }
            <app-button class="back" (click)="showPackageSelector = false">
                <i class="fas fa-arrow-left"></i>
                <span i18n>Terug</span>
            </app-button>
        </div>
        }
    </div>
</ng-template>
